import client from './api-client';
export const getConfiguracionForm17 = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);

        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form17: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboMotivoDescuento = async(query) => {
    try {
        
        const response = await client.get(`detalles?q=${query}`);
        
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboMotivoDescuento: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getSolicitudDescuento = async(query) => {
    try {
        
        const response = await client.get(`getion-implicado/sol-descuento?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                solicitudesAnteriores: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const postActualizarSolicitud = async(file) => {
    try {
        
        const response = await client.post('getion-implicado/sol-descuento ', file);
        if (response.status === 200 && response.data.code === 1) {
            return {respuestaModalSolicitud: response.data};
        } else {
            return {respuestaModalSolicitud: response.data};
        }

    } catch(error){
        throw error;
    }
}